import { oc } from '@orpc/contract';
import { estimateDetailSchema, selectQuickCategoryInputSchema } from '../schemas/estimates.schemas.js';
/**
 * Keeps the closest scenario as an **early indicator label**. It is saved with an activity row and
 * never feeds the valuation — the inspection does (plan §5.11).
 */
export const selectEstimateQuickCategoryContract = oc
    .route({
    method: 'POST',
    path: '/estimates/{estimateId}/quick-category',
    tags: ['Estimates'],
    summary: 'Keep one quick-range scenario as the early indicator',
})
    .input(selectQuickCategoryInputSchema)
    .output(estimateDetailSchema);
//# sourceMappingURL=select-estimate-quick-category.contract.js.map